module.exports = __webpack_public_path__ + "static/media/instagram.4f209560.svg";